<template>
  <div class="c-add-tags">
    <Row :gutter="12" class="c-input-box flex-box">
      <div style="flex: 1">
        <Input v-model="inputTagValue" @on-keypress="handlePress" placeholder="空格分隔,最多十个,每个标签不超过10个字符">
          <span slot="append" @click="add" style="padding: 0 8px; cursor: pointer">添加</span>
        </Input>
      </div>
      <Button @click="labelModel = true" type="primary" style="margin-right: 0; margin-left: 8px">选择创意标签</Button>
    </Row>
    <Row :gutter="12" class="c-input-box">
      <div v-if="lenState" class="c-tags-content">
        <Tag v-for="(tag, idx) in value" :key="idx" :name="tag" @on-close="handleClose" closable>{{ tag }}</Tag>
        <a @click="handleClear" href="javascript:;" class="g-error-text c-tags-betch">清空</a>
      </div>
      <div v-if="err || err1" class="c-tags-err">
        <span v-if="err">单个标签长度应在1~10个字符之间</span>
        <span v-if="err1">标签最多10个</span>
      </div>
    </Row>
    <!-- 标签组 -->
    <select-label v-model="labelModel" :open-id="openId" @on-select="importLabelHandler" />
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils'
import SelectLabel from './components/select-label.vue'
export default {
  name: 'AddTags',
  components: { SelectLabel },
  props: {
    value: {
      type: [Array, String],
      default() {
        return []
      }
    },
    openId: {
      type: [Number, String]
    }
  },
  data() {
    return {
      err: null,
      err1: null,
      labelModel: null,
      inputTagValue: ''
    }
  },
  computed: {
    lenState() {
      return this.value && this.value.length
    }
  },
  methods: {
    add() {
      if (!this.inputTagValue) {
        this.err = true
        return false
      } else {
        let tags = this.inputTagValue.split(' ')
        tags = tags.filter((ret) => ret)
        const res = new Set([...this.value, ...tags])
        const valid = tags.every((ret) => ret.length > 10)
        if (valid) {
          this.err = true
          return false
        }
        if ([...res].length > 10) {
          this.err1 = true
          return false
        }
        this.$emit('input', [...res])
        this.inputTagValue = ''
        this.err = null
        this.err1 = null
      }
    },
    // 选择创意标签
    importLabelHandler(vals) {
      if (!isArray(vals)) return
      vals = vals.map((ret) => ret.name)
      const res = new Set([...this.value, ...vals])
      if ([...res].length > 10) this.err1 = true
      this.$emit(
        'input',
        [...res].filter((a, i) => i < 10)
      )
    },
    handleClose(e, name) {
      this.$emit('on-close', name)
      this.err = null
      this.err1 = null
    },
    handleClear() {
      this.$emit('input', [])
      this.err = null
      this.err1 = null
    },
    handlePress(e) {
      if (e.keyCode === 13) this.add()
    }
  }
}
</script>
<style lang="scss" scoped>
.c-input-box {
  padding: 0 5px;
  position: relative;
}

.flex-box {
  display: flex;
}

.c-tags-content {
  padding: 6px 12px;
  border: solid 1px #dee4f5;
  margin-top: 10px;

  .c-tags-betch {
    line-height: 22px;
    white-space: nowrap;
  }
}

.c-tags-err {
  margin-top: 10px;
  font-size: 14px;
  line-height: 28px;
  color: red;

  span {
    display: block;
  }
}

::v-deep .ivu-tag .ivu-tag-text {
  width: auto;
}

::v-deep .ivu-input-group-append {
  cursor: pointer;
}
</style>
